export const HOME = {
  WIDGETS_home_layout: 'WIDGETS_home_layout',
  RANGE_home_alertSummary: 'RANGE_home_alertSummary',
};
